<div class="wrapper step-three">
    <div class="step-content">

        <div class="templates position-relative">
            <div class="arrows-left position-absolute" id="left">
                <img
                        (click)="scroll(target, 'left')"
                        src="./assets/imgs/Arrow-slider-left.svg"
                />
            </div>
            <div class="arrows-right position-absolute" id="right">
                <img (click)="scroll(target, 'right')" src="./assets/imgs/Arrow-slider-right.svg" />
            </div>
            <div #target class="grid">
                <button type="button" class="btn btn-outline-primary" *ngFor="let button of buttons.resButton; let i = index"
                        id="{{ buttons.timestamp + i }}"    
                        (click)="sendMessage(button.text,buttons.timestamp + i, buttons.timestamp + i + 100)">
                    <div class="d-flex">
                        <span 
                              style="font-size: 12px;min-width: 8rem;"
                              id="{{ buttons.timestamp + i + 100 }}"
                              >
                    {{button.text}}</span>
                    </div>
                </button>
            </div>
            <span style="float: right;font-size: 12px;">{{currentBtn}}/{{buttons.resButton.length}}</span>
        </div>
        <!-- <button
          routerLink="/design-menu/step-three"
          class="next btn bg-gold text-white mt-5"
        >
          {{ "common.next" | translate }}
        </button> -->
    </div>
</div>
